"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualHomeBicyclesWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var services_1 = require("@falcon/services");
var uuid_1 = require("uuid");
var journey_services_1 = require("@athena-portal/journey-services");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../../../Types");
var ConfirmModal_1 = require("../../../../components/modals/ConfirmModal");
var AnnualHomeBicylecInfo_1 = require("./AnnualHomeBicylecInfo");
var BicycleInfoModal_1 = require("./BicycleInfoModal");
var AnnualHomeBicycleModal_1 = require("./AnnualHomeBicycleModal");
var journey_model_1 = require("@athena-portal/journey-model");
var commonFunctions_1 = require("../../../../commonFunctions");
var OptionalExtrasQuestionWidgetBase_1 = require("../../common/OptionalExtrasQuestionWidgetBase");
var AnnualHomeBicyclesWidget = /** @class */ (function (_super) {
    __extends(AnnualHomeBicyclesWidget, _super);
    function AnnualHomeBicyclesWidget(props) {
        var _a;
        var _this = _super.call(this, props) || this;
        _this.handleOnChangeEvent = function () {
            if (_this.props.interaction.uistate.annualHomeAddonsState.bicycles == null) {
                journey_services_1.ObjectManipulator.setField("uistate.optionalExtraPreviouslyEmptyNowUnselected", _this.props.interaction, true);
            }
            journey_services_1.ObjectManipulator.setField("uistate.annualHomeAddonsState.bicycles", _this.props.interaction, false);
            _this.validateInternal("annualHomeBicycles", false);
            _this.executeEvent("change");
        };
        _this.state = {
            isInfoModalOpen: false,
            isAddItemModalOpen: false,
            isRemovalModalOpen: false,
            tieredUnderwritingResult: _this.props.interaction.tieredUnderwritingResult,
        };
        _this.toggleInfoModal = _this.toggleInfoModal.bind(_this);
        _this.toggleAddItemModal = _this.toggleAddItemModal.bind(_this);
        _this.toggleRemovalModal = _this.toggleRemovalModal.bind(_this);
        _this.removeBicycleEvent = _this.removeBicycleEvent.bind(_this);
        _this.addOrEditItem = _this.addOrEditItem.bind(_this);
        _this.editItem = _this.editItem.bind(_this);
        _this.removeItem = _this.removeItem.bind(_this);
        var addonsState = (_a = _this.props.interaction.uistate) === null || _a === void 0 ? void 0 : _a.annualHomeAddonsState;
        if (_this.getSetting("resetUnselectedAddons", false) && addonsState && !addonsState.bicycles) {
            addonsState.bicycles = null;
        }
        return _this;
    }
    AnnualHomeBicyclesWidget.prototype.render = function () {
        var _a, _b;
        var bicycles = this.props.interaction.bicycles;
        var filteredBicycles = bicycles && this.props.interaction.bicycles
            .filter(function (bicycle) { return bicycle.flowValuable; });
        var hasBicycles = filteredBicycles && filteredBicycles.length > 0;
        var backgroundClass;
        var widgetIcon;
        var wording;
        var validationErrors = (0, commonFunctions_1.getValidationErrors)(this.props, "annualHomeBicycles");
        var hasValidationErrors = ((_a = validationErrors === null || validationErrors === void 0 ? void 0 : validationErrors.length) !== null && _a !== void 0 ? _a : 0) > 0;
        if (hasBicycles) {
            backgroundClass = "fixed-addon-background-selected";
            widgetIcon = (0, jsx_runtime_1.jsx)("img", { className: "fixed-addon-icon float-left", src: "/".concat(services_1.resourcesHelper.THEME, "/img/fixed-addon-selected-tick.png"), alt: "addon selected icon" });
            wording = (0, jsx_runtime_1.jsx)("p", { className: "mt-0 mb-0", children: "Covered in and out from your home" });
        }
        else {
            backgroundClass = "fixed-addon-background";
            widgetIcon =
                (0, jsx_runtime_1.jsx)("img", { className: "fixed-addon-icon float-left", src: "/".concat(services_1.resourcesHelper.THEME, "/img/bicycle-icon.png"), alt: "addon icon" });
            wording = (0, jsx_runtime_1.jsxs)("p", { className: "mt-0 mb-0", children: ["Add bicycles that are worth over ", (0, jsx_runtime_1.jsx)("span", { className: "font-weight-700", children: "\u00A3350" }), " each to be covered in and out of your home"] });
        }
        return ((0, jsx_runtime_1.jsx)("div", { id: "annualHomeBicycles", className: "".concat(backgroundClass, " quote row mt-2 pb-0 position-relative ").concat(hasValidationErrors ? "is-invalid" : ""), children: (0, jsx_runtime_1.jsxs)("div", { className: "col p-0 fixed-addon-item", children: [widgetIcon, (0, jsx_runtime_1.jsxs)("div", { className: "fixed-addon-content", children: [(0, jsx_runtime_1.jsxs)("div", { className: "heading-info", children: [(0, jsx_runtime_1.jsx)("p", { className: "font-weight-bold mt-0 mb-0 heading", children: "Bicycles" }), (0, jsx_runtime_1.jsx)("button", { className: "fixed-addon-info cursor-pointer info-button", onClick: this.toggleInfoModal })] }), wording, this.renderAddedItems(filteredBicycles)] }), hasValidationErrors &&
                        (0, jsx_runtime_1.jsx)("div", { className: "invalid-feedback d-block", children: (_b = validationErrors[0]) === null || _b === void 0 ? void 0 : _b.errorMessage }), (0, jsx_runtime_1.jsxs)("div", { className: "fixed-addon-buttons", children: [!this.itemLimitReached() && this.renderAddLink(hasBicycles), (0, jsx_runtime_1.jsx)(BicycleInfoModal_1.default, { closeModal: this.toggleInfoModal, isOpen: this.state.isInfoModalOpen }), this.renderAddItemModal(), this.renderItemRemovalModal()] })] }) }));
    };
    AnnualHomeBicyclesWidget.prototype.renderAddLink = function (hasBicycles) {
        var _a, _b;
        var noThanksSelected = ((_b = (_a = this.props.interaction.uistate) === null || _a === void 0 ? void 0 : _a.annualHomeAddonsState) === null || _b === void 0 ? void 0 : _b.bicycles) === false;
        return ((0, jsx_runtime_1.jsxs)("div", { className: "optional-extra-btn-container", children: [(0, jsx_runtime_1.jsx)("button", { onClick: this.toggleAddItemModal, className: "".concat(hasBicycles ? "optional-extra-btn-added-item" : "optional-extra-btn-no-items"), children: "Add bicycle" }), !hasBicycles && (0, jsx_runtime_1.jsx)("button", { onClick: this.handleOnChangeEvent, className: noThanksSelected ? "optional-extra-btn" : "optional-extra-btn-no-items", children: noThanksSelected ? "Not added" : "No, thanks" })] }));
    };
    AnnualHomeBicyclesWidget.prototype.renderAddedItems = function (bicycles) {
        return ((0, jsx_runtime_1.jsx)(AnnualHomeBicylecInfo_1.default, { bicycles: bicycles, editBicycle: this.editItem, removeBicycle: this.removeBicycleEvent }));
    };
    AnnualHomeBicyclesWidget.prototype.renderAddItemModal = function () {
        var item;
        var title;
        var buttonText;
        if (this.state.editItem) {
            item = this.state.editItem;
            title = "Edit bicycle";
            buttonText = "Confirm Changes";
        }
        else {
            item = new services_1.AnnualHomeValuableItem();
            item.valuableItemId = (0, uuid_1.v4)();
            title = "Add bicycle";
            buttonText = "Add bicycle";
        }
        return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: this.state.isAddItemModalOpen && (0, jsx_runtime_1.jsx)(AnnualHomeBicycleModal_1.default, { title: title, buttonText: buttonText, item: item, interaction: this.props.interaction, closeModal: this.toggleAddItemModal, onConfirm: this.addOrEditItem, addPhotoEnabled: this.getSetting("addPhotoEnabled", true) }) }));
    };
    AnnualHomeBicyclesWidget.prototype.renderItemRemovalModal = function () {
        return ((0, jsx_runtime_1.jsx)(ConfirmModal_1.default, { show: this.state.isRemovalModalOpen, onHide: this.toggleRemovalModal, onConfirm: this.removeItem, confirmButtonText: "Yes, please", children: (0, jsx_runtime_1.jsx)("div", { className: "fs-20 font-weight-medium font-family-display", children: "Are you sure you want to remove this item?" }) }));
    };
    AnnualHomeBicyclesWidget.prototype.toggleInfoModal = function () {
        this.setState({
            isInfoModalOpen: !this.state.isInfoModalOpen
        });
    };
    AnnualHomeBicyclesWidget.prototype.toggleAddItemModal = function () {
        var _a;
        var newValue = !this.state.isAddItemModalOpen;
        this.setState({
            isAddItemModalOpen: newValue
        });
        if (!newValue) {
            if (((_a = this.state.editItem) === null || _a === void 0 ? void 0 : _a.coverLocation) === services_1.ValuableItemCoverLocation.HOME) {
                this.remove(this.state.editItem);
            }
            this.setState({
                editItem: undefined
            });
        }
    };
    AnnualHomeBicyclesWidget.prototype.toggleRemovalModal = function () {
        this.setState({
            isRemovalModalOpen: !this.state.isRemovalModalOpen
        });
    };
    AnnualHomeBicyclesWidget.prototype.removeBicycleEvent = function (bicycle) {
        this.setState({
            removeItem: bicycle
        });
        this.toggleRemovalModal();
    };
    AnnualHomeBicyclesWidget.prototype.addOrEditItem = function (bicycle) {
        var bicycles = this.props.interaction.bicycles ? __spreadArray([], this.props.interaction.bicycles, true) : [];
        if ((bicycles === null || bicycles === void 0 ? void 0 : bicycles.filter(function (innerItem) { return innerItem.valuableItemId === bicycle.valuableItemId; }).length) === 0) {
            bicycles.push(bicycle);
        }
        else {
            bicycles = bicycles === null || bicycles === void 0 ? void 0 : bicycles.map(function (innerItem) {
                return innerItem.valuableItemId === bicycle.valuableItemId ? bicycle : innerItem;
            });
        }
        journey_services_1.ObjectManipulator.setFieldWithTrackChanges("bicycles", bicycles, {
            interaction: this.props.interaction,
            initialInteraction: this.props.initialInteraction,
        });
        journey_services_1.ObjectManipulator.setField("uistate.annualHomeAddonsState.bicycles", this.props.interaction, true);
        this.executeEvent("change");
        this.changelogRecorder.recordPage("change", this.props, "bicycles");
        this.setState({
            isAddItemModalOpen: false,
            editItem: undefined
        });
    };
    AnnualHomeBicyclesWidget.prototype.editItem = function (bicycle) {
        this.setState({
            editItem: bicycle
        });
        this.toggleAddItemModal();
    };
    AnnualHomeBicyclesWidget.prototype.removeItem = function () {
        if (this.state.removeItem) {
            this.remove(this.state.removeItem);
            this.toggleRemovalModal();
            this.setState({
                removeItem: undefined
            });
        }
    };
    AnnualHomeBicyclesWidget.prototype.remove = function (item) {
        var _a;
        var bicycles = ((_a = this.props.interaction.bicycles) !== null && _a !== void 0 ? _a : []).filter(function (i) { return i.valuableItemId !== item.valuableItemId; });
        journey_services_1.ObjectManipulator.setField("uistate.annualHomeAddonsState.bicycles", this.props.interaction, bicycles.length > 0);
        journey_services_1.ObjectManipulator.setFieldWithTrackChanges("bicycles", bicycles, {
            interaction: this.props.interaction,
            initialInteraction: this.props.initialInteraction,
        });
        this.executeEvent("change");
        this.changelogRecorder.recordPage("change", this.props, "bicycles");
    };
    AnnualHomeBicyclesWidget.prototype.itemLimitReached = function () {
        return this.props.interaction.bicycles && this.props.interaction.bicycles.length >= 16;
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.ChangelogRecorder),
        __metadata("design:type", Object)
    ], AnnualHomeBicyclesWidget.prototype, "changelogRecorder", void 0);
    AnnualHomeBicyclesWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "addPhotoEnabled", type: journey_model_1.TypeDescriptions.Boolean },
            { name: "resetUnselectedAddons", type: journey_model_1.TypeDescriptions.Boolean },
        ]),
        __metadata("design:paramtypes", [Object])
    ], AnnualHomeBicyclesWidget);
    return AnnualHomeBicyclesWidget;
}(OptionalExtrasQuestionWidgetBase_1.OptionalExtrasQuestionWidgetBase));
exports.AnnualHomeBicyclesWidget = AnnualHomeBicyclesWidget;
//# sourceMappingURL=AnnualHomeBicyclesWidget.js.map